export default __webpack_public_path__ + "static/media/sk.31baf042.png";